import type { ReactNode } from 'react';

import Button from './Button';

interface Props {
    id: string;
    submitLabel: string;
    loadingSubmitLabel?: string;
    submitIcon?: ReactNode;
    onSubmit: () => void;
    cancelLabel: string;
    onCancel: () => void;
    style?: 'primary' | 'danger';
    isLoading?: boolean;
}

const DialogFooter = ({
    id,
    submitLabel,
    loadingSubmitLabel,
    submitIcon,
    onSubmit,
    cancelLabel,
    onCancel,
    style,
    isLoading,
}: Props) => (
    <div className='display-flex justify-content-end gap-10'>
        <Button data-testid={`${id}-dialog-cancel-button`} onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
        </Button>
        <Button data-testid={`${id}-dialog-submit-button`} onClick={onSubmit} style={style} isLoading={isLoading}>
            {!isLoading && submitIcon}
            {isLoading && loadingSubmitLabel ? loadingSubmitLabel : submitLabel}
        </Button>
    </div>
);

export default DialogFooter;
